<template>
  <div id="footer" class="container-fluid">
    <div class="mask"></div>
    <div class="footer-content">
    <template v-if="$store.getters.getShowEn">
    <p class="title">Easy Solutions International Forwarding Co., Ltd</p>
    <p class="address_tel_fax">
      <span>Address：Room 1804,Yinggang International,No.577,Jinggang Avenue，Nansha District,Guangzhou,China</span>
    </p>
    <p class="email_wx">
      <span>E-Mail：kelly.zheng@w-esolutions.com</span>
    </p>
    </template>
    <template v-else>
    <p class="title">广州易航国际货运代理有限公司</p>
    <p class="address_tel_fax">
      <span>地址：广州市南沙区进港大道577号盈港国际1804室</span>
    </p>
    <p class="email_wx">
      <span>邮箱：kelly.zheng@w-esolutions.com</span>
    </p>
    </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  /* background-image: url(../assets/img/67373608_2784138464933662_8277927233947959296_o.jpg); */
  background-color: black;
  background-position: center center;
  padding: 60px 0px;
  overflow: hidden;
  text-align: center;
  position: relative;
  z-index: -1;
  padding: 15px;
}

.mask{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: rgba(0,0,0,0.4);
  z-index: 2;
}
.footer-content{
  position: relative;
  z-index: 5;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 20px;
  margin-top: 10px;
}
.address_tel_fax {
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  font-size: 14px;
}
.copy {
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue